"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CategoryOfProductSingleLevelField;

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _formFields = require("react-platform-components/dist/form-fields");

var _formValidators = require("react-platform-components/dist/form-validators");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CategoryOfProductSingleLevelField(props) {
  var categories = props.categories;

  var childrenCategories = _lodash.default.orderBy(categories, ['name'], ['asc']).filter(function (cat) {
    return cat.is_final;
  });

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.Select, {
    variant: "outlined",
    fullWidth: true,
    required: true,
    label: "Cat\xE9gorie",
    name: "category",
    margin: "normal",
    validate: (0, _formValidators.required)()
  }, childrenCategories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: category.id,
      value: category.id
    }, category.name);
  })));
}